<div class="purity-of-2-hydroxyethyl-methacrylate-container">
    <div class="purity-of-2-hydroxyethyl-methacrylate-item-container">
        <div class="purity-of-2-hydroxyethyl-methacrylate-item-input-container">
            <mat-form-field appearance="outline" class="purity-of-2-hydroxyethyl-methacrylate-form-field">
                <mat-label>Purity of 2-hydroxyethyl methacrylate (if applicable)</mat-label>
                <input matInput #purityOf2HydroxyethylMethacrylateInput [(ngModel)]="purityOf2HydroxyethylMethacrylate"
                    class="purity-of-2-hydroxyethyl-methacrylate purity-of-2-hydroxyethyl-methacrylate-item-input"
                    (keyup.enter)="updatePurityOf2HydroxyethylMethacrylate($event)" (keyup.escape)="cancelUpdate()"
                    (blur)="updatePurityOf2HydroxyethylMethacrylate($event)" />
                <mat-icon matSuffix (mousedown)="clearPurityOf2HydroxyethylMethacrylateInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
</div>